module.exports = __webpack_public_path__ + "img/yinhao_left.ac6455f6.png";